export const MERCH = '/merch/' as const
export const PRODUCT_ITEM = `${MERCH}item/` as const
export const PRODUCT_ITEM_CLIENT = `${MERCH}item/client/` as const
export const PRODUCT_ITEM_ALL = `${PRODUCT_ITEM}all` as const
export const PRODUCT_ITEM_STATUS = `${PRODUCT_ITEM}status/` as const
export const PRODUCT_ITEM_ALL_SHORT = `${PRODUCT_ITEM_ALL}/short` as const

export const PRODUCT_CATEGORY = `${MERCH}category/` as const
export const PRODUCT_CATEGORY_ALL = `${PRODUCT_CATEGORY}all` as const

export const PRODUCT_COLOR = `${MERCH}color/` as const
export const PRODUCT_COLOR_ALL = `${PRODUCT_COLOR}all` as const

export const PRODUCT_SIZE = `${MERCH}size/` as const
export const PRODUCT_SIZE_ALL = `${PRODUCT_SIZE}all` as const

export const PRODUCT_MATERIAL = `${MERCH}material/` as const
export const PRODUCT_MATERIAL_ALL = `${PRODUCT_MATERIAL}all` as const

export const PRODUCT_TRADE = `${MERCH}trade/` as const
export const PRODUCT_TRADE_ALL = `${PRODUCT_TRADE}all` as const
export const PRODUCT_DECLINE = `${PRODUCT_TRADE}decline_order/` as const
export const PRODUCT_MARK_DELIVERED = `${PRODUCT_TRADE}mark-delivered/` as const
export const PRODUCT_CONFIRM_PAYMENTS = `${PRODUCT_TRADE}confirm_payments` as const

export const PRODUCT_CONFIRM_PAYMENTS_BY_ID = `${PRODUCT_TRADE}confirm_payments/` as const

export const PRODUCT_TRADE_BUYER_ALL = `${PRODUCT_TRADE}by_buyer/all` as const

export const PRODUCT_TRADE_RETURN = `${PRODUCT_TRADE}return/` as const
export const PRODUCT_TRADE_ACCEPT = `${PRODUCT_TRADE_RETURN}accept/{id}` as const
export const PRODUCT_TRADE_MARK = `${PRODUCT_TRADE_RETURN}mark/{id}` as const
export const PRODUCT_TRADE_REQUEST = `${PRODUCT_TRADE_RETURN}request/{id}` as const
export const PRODUCT_TRADE_PAYMENT_RETURNED = `${MERCH}trade/payment/` as const
